import apiService from '@/services/apiService';

const actions = {
  getTncContents({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('tnc/find-with-paging', payload)
        .then((response) => {
          resolve(response);
          // commit('getTncContents', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTncContent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`tnc/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getTncContent', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderTnc({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`tnc/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postTnc({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('tnc', payload)
        .then((response) => {
          commit(`postTnc${payload.interface}`, payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putTnc({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`tnc/${payload.id}`, payload.tncData)
        .then((response) => {
          commit(`putTnc${payload.tncData.interface}`, payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delTnc({ commit }, payload) {
    apiService.delete(`tnc/${payload.id}`)
      .then((response) => {
        commit(`delTnc${payload.interface}`, payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
